import { DataBean } from "../DataBean";

export class ProductVariant extends DataBean {


    public async getProductVariantCatalog(idProduct:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductVariantCatalog_Number", [idProduct]);
    }
    

    public async getProductVariantCatalogByManufacturingStandard(idProduct:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductVariantCatalogByManufacturingStandard_Number", [idProduct]);
    }
 
}